export enum ErrorCodes {
    LOGIN_NEEDED = "loginNeeded"
}
